<template>
  <b-container>
    <div id="login">
      <form @submit.prevent="requestLogin">
        <div id="login-logo-header">
          <img src="../assets/Edith.png" alt="Edith Logo" height="120px" width="180px"
               id="login-logo-img" style="margin-left: 264px"/>
        </div>
        <p class="h4 text-center mb-4 " style="margin-top: 15px">Willkommen auf der Webseite des EDiTh-CDSS.</p>
        <p class="h5 text-justify mb-3" style="margin-top: 15px">Dieses System in ein Online-System, welches zu Zwecken
          der Ausbildung die Funktionen eines Entscheidungsunterstützenden Systems (CDSS) zur Leitliniengerechten
          Diagnostik und Therapie der Epilepsie demonstriert.
        </p>
        <p class="h5 text-center mb-3" style="margin-top: 20px; color: red">
          <b-icon icon="exclamation-triangle" variant="danger"></b-icon>
          WICHTIGER HINWEIS
          <b-icon icon="exclamation-triangle" variant="danger"></b-icon>
        </p>
        <p class="h5 text-justify mb-3" style="color: red">
          Das System ist KEIN Medizinprodukt. Es darf nicht in der Patientenversorgung angewendet werden. Die von
          dem System bereitgestellten Informationen dürfen nicht für medizinische Entscheidungen verwendet werden.
          <br> Bitte beachten Sie, dass das System keine Aktualisierung der medizinischen Behandlungsstandards der
          Epilepsieerkrankung abbildet!
        </p>
        <p class="h5 text-justify mb-3" style="margin-top: 15px">Nutzungshinweis: Aktuell ist die Nutzung nur für
          Angehörige der RWTH Aachen und der Uniklinik RWHT Aachen freigegeben. Sollten Sie als Hochschule oder
          Bildungseinrichtung Interesse an der Nutzung haben, wenden Sie sich bitte an: <a
              href="mailto:medizininformatik@ukaachen.de">medizininformatik@ukaachen.de</a>
        </p>
        <p class="h5 text-center mb-3" style="margin-top: 15px">Weitere Informationen finden Sie unter <a
            href="https://www.medizin.uni-tuebingen.de/de/das-klinikum/pressemeldungen/603" target="_blank">EDiTh-Projekt</a>
        </p>
        <div class="text-center mt-4">
          <button class="btn btn-primary">Start
          </button>
        </div>
      </form>
    </div>
    <div id="version" class="aligncenter" style="color: #5a6268; margin-top: 50px">
      <span>EDiTh Version  {{ $store.getters.appVersion }} REO</span>
      <div></div>
      <!-- Left: Institution -->
      <div style="color: #5a6268">
        © 2022-2025 <span> Uniklinik RWTH Aachen</span>. Sämtliche Rechte vorbehalten. <a
          href="https://www.ukaachen.de/impressum/"
          target="_blank">Impressum</a>
      </div>
      <!-- Right: Developers -->
      <div style="color: #5a6268">
        <span>Entwickelt vom
          <a href="https://www.ukaachen.de/kliniken-institute/institut-fuer-medizinische-informatik/imi-home/"
             class="hover:text-white">Institut für Medizinische Informatik</a> und der <a
              href="https://www.ukaachen.de/kliniken-institute/klinik-fuer-neurologie/klinik/sektionen/epileptologie/"
              class="hover:text-white">Abteilung für Epileptologie der Klinik für Neurologie</a> der <a
              href="https://www.ukaachen.de"
              class="hover:text-white">Uniklinik RWTH Aachen</a>
        </span>
      </div>
      <div>Unterstützt durch eine Förderung des Ministeriums für Soziales und Integration Baden-Württemberg</div>
    </div>


  </b-container>


</template>

<script>


export default {
  name: 'Login',
  emits: {
    requestLogin: null,
  },
  beforeMount() {
    // Remove the confirmation dialog when the user closes or reloads the page on the login site
    window.onbeforeunload = null
  },
  methods: {
    requestLogin() {
      this.$emit('requestLogin')

    }
  },
}
</script>

<style scoped>
#login {
  width: 750px;
  border: 1px solid #CCCCCC;
  background-color: #FFFFFF;
  margin: auto;
  margin-top: 50px;
  padding: 20px;
  border-radius: 8px;
}

#login-logo-header {
  border: 5px solid #65c0ce;
  background-color: #f1f1f2;
  align-content: center;
}


#login-logo-img {
  margin-left: -1px;
}

.image-border {
  border: 2px solid #000000
}

#2fa-modal {
  max-height: calc(100vh - 225px);
}

.aligncenter {
  text-align: center;
}

.justify-text {
  text-align: justify;
  text-justify: inter-word
}

.colored-number {
  color: red;
  font-size: 20px;
}
</style>